import React from 'react'
import ieee2018project from '../ieee2018project.jpg';
import ieeesig from '../ieeesig.jpg';
import cgpa10 from '../cgpa10.jpg';
import java2016solo from '../java2016solo.jpg';
import javaaptech from '../javaaptech.jpg';
import class12 from '../class12.jpg';
import igdtu from '../igdtu.jpg';
import javacn from '../javacn.jpg';
import math from '../math.jpg';
import n1 from '../NokiaTalent.png';
import n2 from '../JatinN1.png';
import android from '../Android.jpg';
import icpc from '../icpc.png';
import fb from '../fb.png';
import leetcode from '../leetcode.png';
import ta from '../ta.jpg';
import speed from '../speedcon.jpg';


function WallOfFame() {
    return ( 
<div>
    <div className="mainHeadingAbout">
                WALL OF FAME
    </div>
    
    <div className="mainWalloffame">
        <a href={n1} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + n1 + ")"}} >
                <p>Nokia's Got Talent</p> 
            </div>
        </a>
        <a href={n2} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + n2 + ")"}} >
                <p>Nokia Award</p> 
            </div>
        </a>
        <a href={icpc} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + icpc + ")"}} >
                <p>ICPC North America</p> 
            </div>
        </a>
        <a href={fb} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + fb + ")"}} >
                <p>Facebook HackerCup</p> 
            </div>
        </a>
        <a href={leetcode} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + leetcode + ")"}} >
                <p>Leetcode Profile</p> 
            </div>
        </a>
       
        
        












<a href={speed} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + speed + ")"}} >
                <p>Research Paper Presentation</p> 
            </div>
        </a> 
<a href={ta} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + ta + ")"}} >
                <p>Teaching Assistant</p> 
            </div>
        </a> 
        <a href={ieee2018project} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + ieee2018project + ")"}} >
                <p>IEEE Project</p> 
            </div>
        </a> 
         <a href={android} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + android + ")"}}>
            <p>Android certification</p> 
        </div>
        </a>
        <a href={ieeesig} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + ieeesig + ")"}}>
            <p>Appreciation Letter IEEE</p> 
        </div>
        
        </a>
        
        <a href={javacn} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + javacn + ")"}}>
            <p>DS and Algo certification</p> 
        </div>
        </a>
        <a href={igdtu} target="_blank">
        <div class="wof_image" style={{backgroundImage: "url(" + igdtu + ")"}}>
            <p>IGDTU Coding Contest</p> 
        </div>
        </a>
   <a href={math} target="_blank">
            <div class="wof_image" style={{backgroundImage: "url(" + math + ")"}} >
                <p>Silver Medal in Maths</p> 
            </div>
        </a>

        <a href={javaaptech} target="_blank">
        <div class="wof_image" style={{backgroundImage: "url(" + javaaptech + ")"}}>
            <p>Java Certification</p> 
        </div>
        </a>

<a href={class12} target="_blank">
<div class="wof_image" style={{backgroundImage: "url(" + class12 + ")"}}>
            <p>Class 12th Award</p> 
        </div>
</a>

        <a href={cgpa10} target="_blank">
<div class="wof_image" style={{backgroundImage: "url(" + cgpa10 + ")"}}>
            <p>10th CGPA</p> 
        </div>
         </a>
    
    </div>
        *Only selected certifications and awards have been listed. Other achievements such as research paper awards, coding contests certifications, learning certifications on Linkedin/Coursera/Udemy etc, invited talks etc has not been included 
</div>
 

 
    )
}

export default WallOfFame;
